import { useEffect } from "react";
import Lenis from "lenis";

const ref = { current: null };

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    ref.current = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      ref.current = null;
    };
  }, []);
}

export function scrollToId(id) {
  const el = document.querySelector(id);
  if (!el) return;
  if (ref.current) ref.current.scrollTo(el, { offset: -90, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}
